export default __webpack_public_path__ + "assets/images/a8ef685d686feeb0a408beb691d7ba81.png";